const toJson = (item, listMenu) => {
  return {
    _id: item._id,
    name: item.name,
    nameEn: item.nameEn,
    diaChi: item.diaChi,
    diaChiEn: item.diaChiEn,
    sdt: item.sdt,
    content: item.content,
    contentEn: item.contentEn,
    link: item.link,
    traiCay: item.traiCay ?? [],
  };
};

const fromJson = (item) => {
  return {
    _id: item._id,
    name: item.name,
    nameEn: item.nameEn,
    diaChi: item.diaChi,
    diaChiEn: item.diaChiEn,
    sdt: item.sdt,
    content: item.content,
    contentEn: item.contentEn,
    link: item.link,
    traiCay: item.traiCay ?? [],
  };
};

const baseJson = () => {
  return {
    _id: null,
    name: null,
    nameEn: null,
    diaChi: null,
    diaChiEn: null,
    sdt: null,
    content: null,
    contentEn: null,
    link: null,
    traiCay: [],
  };
};

const toListModel = (items) => {
  if (items?.length > 0) {
    return items.map((value) => ({
      id: value._id,
      name: value.label ?? value.name,
    }));
  }

  return [];
};

export const doanhNghiepModel = {
  toJson,
  fromJson,
  baseJson,
  toListModel,
};
